// extracted by mini-css-extract-plugin
var _1 = "mbE_FwzN";
export { _1 as "expired" }
